import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Courier New - system font, no external loading needed
export const CourierNewFontFaces: ExcalidrawFontFaceDescriptor[] = [];